import React from 'react'
import PropTypes from 'prop-types'
import { Heading } from '@rebeldotcom/components'
import DesignSystemLayout from '../layout/design-system-layout'

const propTypes = {
  strings: PropTypes.shape({
    mainHeading: PropTypes.string,
  }).isRequired,
}

const DesignSystem = ({ strings }) => {
  return (
    <DesignSystemLayout>
      <Heading as="h1" variant="petaBold">
        {strings.mainHeading}
      </Heading>
    </DesignSystemLayout>
  )
}

DesignSystem.propTypes = propTypes

export { DesignSystem }
